<template>
  <!-- cookie acceptance screen when logging into the system, it must be accepted every time when logging in -->

  <div
    class="modal bd-example-modal-md"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    id="discardChangesEdit"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="card-title text-center text-join">Confirmar ação</h5>
        </div>
        <div class="modal-body">
          <div style="justify-content: center; display: flex; font-size: 16px">
            Você realmente deseja descartar as alterações?
          </div>
          <div class="access-center">
            <button
              class="btn btn-lg access"
              id="keepChangesEdit"
              @click="keepModal"
              type="button"
              style="margin-right: 15px"
            >
              Não
            </button>
            <button
              class="btn btn-lg access"
              id="advancedChangesEdit"
              @click="closeModal"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Sim
            </button>
            <br /><br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DiscardChangesEdit",

  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeModal: function () {
      $("#discardChangesEdit").modal("hide");
      $("#editUserModal").modal("hide");
    },

    keepModal: function () {
    $("#discardChangesEdit").modal("hide");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-backdrop {
  display: none;
}

.modal {
  background: rgba(0, 0, 0, 0.5);
}

.access {
  color: #fff;
  width: 20%;
  margin-top: 5px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 14px;
  margin-bottom: -20px;
}
.access-center {
  justify-content: center;
  display: flex;
  margin-bottom: 25px;
  margin-top: 5%;
}

.modal-dialog {
  margin-top: 13%;
  justify-content: center;
  display: flex;
}

.modal {
  color: rgb(100, 95, 95);
}

label {
  margin-left: 40px;
  margin-left: 35px;
}

.modal-content {
  width: 90%;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  font-family: sans-serif !important;
  font-size: 14px;
}

.modal-header {
  justify-content: center;
}

@media only screen and (max-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 40%;
  }
  label {
    margin-left: 25px;
    margin-bottom: 10px;
  }

  .access {
    color: #fff;
    width: 35%;
    height: 80%;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 14px;
    margin-right: 0px;
    margin-top: 10px;
    margin-bottom: 3px;
  }

  .access-class {
    margin-right: 0px;
    display: flex;
    justify-content: center;
    width: 100% !important;
  }

  .footer-style {
    display: inline;
    margin-top: 27px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/user/edit/DiscardChangesEdit.vue